
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initializeConfig } from './initializeConfig';

const startApp = async () => {
  await initializeConfig();
  ReactDOM.render(<App />, document.getElementById('root'));
};

startApp();
